module.exports = __webpack_public_path__ + "img/hamburger-carte-generale.b0e999fd.jpg";